module.exports = __webpack_public_path__ + "img/Paypal-long.b6b86f0c.png";